import aiSummariesService from '@/services/ai-summaries.service'
import userService from '@/services/user.service'
import { DocumentsAISummaryActionType } from '@/store/modules/documents-ai-summary/action_types'
import { DocumentsAISummaryMutationType } from '@/store/modules/documents-ai-summary/mutation_type'

export const actions: StoreActions<DocumentsAISummaryActionType, DocumentsAISummaryMutationType> = {
  async REQUEST_SUMMARY ({ commit, rootGetters }, documentId) {
    commit('SET_REQUEST_SUMMARY_PENDING', true)
    const roomMnemo = rootGetters['room/roomMnemo'] as string

    try {
      const { data } = await aiSummariesService.requestDocumentAISummary(roomMnemo, documentId)
      return data
    } finally {
      commit('SET_REQUEST_SUMMARY_PENDING', false)
    }
  },
  async LOAD_SUMMARIES_CREDITS ({ commit }) {
    commit('SET_SUMMARIES_CREDITS', null)
    commit('SET_SUMMARIES_CREDITS_PENDING', true)

    try {
      const { data } = await userService.getCurrentUserAICredits()
      commit('SET_SUMMARIES_CREDITS', data)
    } catch (error) {
      commit('SET_SUMMARIES_CREDITS', null)
      throw error
    } finally {
      commit('SET_SUMMARIES_CREDITS_PENDING', false)
    }
  },
}
